import { render, staticRenderFns } from "./ButtonMain.vue?vue&type=template&id=26482e56&lang=pug&"
import script from "./ButtonMain.vue?vue&type=script&lang=js&"
export * from "./ButtonMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports